import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobsResponse } from "@/types";

export function useGetJobsByCompanyId() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["jobs", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs`;
      const res = await guacHttpClient.get<
        JobsResponse[],
        HttpResponse<JobsResponse[]>
      >(path);
      return res.data;
    },
  });
}
